import axios from 'axios';
import { responseOnAxiosResponse, responseOnReject } from './interceptor';
import { store } from '@stb/redux';

const graphqlSgb = axios.create({
  baseURL: process.env.REACT_APP_/dev/stb/web_NODE_STB + '/graphql',
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
  method: 'POST',
});

graphqlSgb.interceptors.request.use(
  (config) => {
    const authData = store.getState().auth;
    if (authData.action === 'LOG_IN') {
      config.headers['Authorization'] = `Bearer ${authData.session.user.access_token}`;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

graphqlSgb.interceptors.response.use(responseOnAxiosResponse, responseOnReject);

export default graphqlSgb;
